import { render, staticRenderFns } from "./PCT.vue?vue&type=template&id=1063a725&scoped=true&"
import script from "./PCT.vue?vue&type=script&lang=js&"
export * from "./PCT.vue?vue&type=script&lang=js&"
import style0 from "./PCT.vue?vue&type=style&index=0&id=1063a725&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1063a725",
  null
  
)

export default component.exports